import { CSSProperties } from 'react';
import { TextContainer } from './styles';
import useScreen from 'Hooks/useScreen';
import { daysUntilRelease, daysUntilReleaseText } from './utils';
import { Severity } from 'modules/Const';
import ButtonSymphony, { ButtonColor } from 'elements/ButtonSymphony';
import Banner from 'elements/Banner';
import Icon from 'elements/Icon';

interface Props {
    songName: string;
    releaseDate: string | Date;
    handleClickAdd: () => void;
}

const WarningNoReleaseUpcCard = ({
    songName,
    releaseDate,
    handleClickAdd,
}: Props) => {
    const { mobileView, mStyle } = useScreen();

    const daysLeft = daysUntilRelease(releaseDate);
    const daysText = daysUntilReleaseText(releaseDate)
    const severity = daysLeft < 0 ? Severity.ERROR : Severity.WARNING;
    const text = severity === Severity.ERROR ?
        'Your Pre-Save campaign is ready to be launched. Please add the release’s UPC / ISRC to have your fans save your release.' :
        `Don't forget to add the UPC / ISRC to your pre-save campaign for "${songName}", releasing ${daysText}.`;

    const severityColor = severity === Severity.ERROR && false ? 'red' : 'yellow';

    return (
        <Banner
            className="warningNoReleaseUpcCard"
            color={severityColor}
            style={mStyle(sty, 'warningNoReleaseUpcCard')}
        >
            <div className="warningNoReleaseUpcCardInner" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 16 }}>
                <Icon
                    className="warningIcon"
                    icon="warning"
                    color={severityColor}
                    size={28}
                    style={{ flexShrink: 0 }}
                />
                <div>{text}</div>
            </div>
            <ButtonSymphony
                className="cardButtonUPC1"
                onClick={handleClickAdd}
                variant="outlined"
                color={severityColor as ButtonColor}
            >
                Add UPC or ISRC
            </ButtonSymphony>
        </Banner>
    );
}

const sty: Record<string, CSSProperties> = {
    warningNoReleaseUpcCard: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
        borderRadius: 8,
    },
    warningNoReleaseUpcCard_mobile: {
        borderRadius: 0,
        flexDirection: 'column',
    }
}

export default WarningNoReleaseUpcCard;